import React from 'react';
import { StyleSheet, View, TouchableOpacity, Dimensions ,ScrollView, FlatList ,ActivityIndicator,Image } from 'react-native';
import { IconButton, Avatar, Card, FAB, Text,Divider,Menu ,Snackbar,Appbar} from 'react-native-paper';
import persianDate from 'persian-date';
import { Rating } from 'react-native-ratings';
import Slider from '@react-native-community/slider';


const sportIcons = { 
  
    "اسپینینگ":
    require("../assets/sportsicons/spin.png"),

    "ایروبیک":
    require("../assets/sportsicons/rhytm.png"),

    "بدنسازی":
    require("../assets/sportsicons/gym.png"),

    "تمرینات فانکشنال / کراسفیت":
    require("../assets/sportsicons/cf.png"),

    "تمرینات لس میلز":
    require("../assets/sportsicons/bp.png"),

    "تمرینات معلق":
    require("../assets/sportsicons/trx.png"),

    "جامپینگ فیتنس":
    require("../assets/sportsicons/jump.png"),

    "فیتنس":
    require("../assets/sportsicons/fit.png"),

    "دوچرخه سواری":
    require("../assets/sportsicons/bike.png"),

    "ورزش های آبی":
    require("../assets/sportsicons/swim.png"),

    "ورزش های آزاد":
    require("../assets/sportsicons/free.png"),

    "ورزش کودکان":
    require("../assets/sportsicons/kids.png"),

    "کیک بوکس / رزمی":
    require("../assets/sportsicons/kb.png"),

    "یوگا / پیلاتس":
    require("../assets/sportsicons/yoga.png"),

    "متفرقه":
    require("../assets/sportsicons/other.png"),
  
 } ;


const width =  Dimensions.get('window').width / 7;

var days =[];
for(let i=0 ; i<14 ; i++){
   days[i]= new persianDate().add('days', i);
};

const TimeStamp = props => (
  
  <View style={{flexDirection:'row',paddingRight:15,marginTop:-8}}>

    <IconButton icon="clock-outline" color="#3a3635" size={18} style={{margin:0,marginTop:3}} />
    <Text style={{fontSize:10,color:'#3a3635', textAlign:'center',marginBottom:-2}}>{props.starttime}{'\n'}{props.endtime}</Text>

  </View>

);


export default class App extends React.Component {

  state = {
    dIndex:0,
    sliderVal:0,
    data : null,
    page :1,
    loadingMore: true,
    refreshing: false,
    visibleSort:false,
    connectionToast:false
  };

  _openSortMenu = () => this.setState({ visibleSort: true });
  _closeSortMenu = () => this.setState({ visibleSort: false });


  _handleLoadMore = () => {
    this.setState(
      (prevState, nextProps) => ({
        page: prevState.page + 1,
        loadingMore: true
      }),
      () => {
        this._fetchClasses();
      }
    );
  };

  _handleRefresh = () => {
    this.setState(
      {
        page: 1,
        refreshing: true
      },
      () => {
        this._fetchClasses();
      }
    );
  };

  _renderFooter = () => {
    if (!this.state.loadingMore){
      if(!(this.state.data.length > 0)){
        return (
          <View
          style={{
            position: 'relative',
            width: '100%',
            paddingVertical: 10
          }}
        >
          <Text style={{ color:'#2ebbc4', marginLeft:'auto', marginRight:'auto',marginTop:5}}>نتیجه ای پیدا نشد</Text>
        </View>
        );
      } else {
        return null;
      }
    }

    return (
      <View
        style={{
          position: 'relative',
          width: '100%',
          paddingVertical: 10
        }}
      >
        <ActivityIndicator animating size="large" />
      </View>
    );
  };

  _fetchClasses = () => {
    const { page } = this.state;
    let data = global.filters;
    data.offset=(page - 1 )*10;

    fetch('https://fitwayz.ir/api/classes',
    {
      method:'POST',
      withCredentials: true,
       
      headers:{
        Accept: 'application/json',
        Authorization: 'Bearer ' + global.token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json()).then(responseJson => {
      this.setState((prevState, nextProps) => ({
        data:
          page === 1
            ? Array.from(responseJson.data)
            : [...this.state.data, ...responseJson.data],

        loadingMore:
        responseJson.data.length < 10
            ? false : true,

        refreshing: false
      }));
    })
    .catch(error => {
      this.setState({connectionToast:false})
    });
  }

 componentDidMount(){

    let date = new Date();
    let formatedDate = date.getFullYear()+'/'+(date.getMonth()+1 )+'/'+date.getDate();

    global.filters.date = formatedDate ;
    fetch('https://fitwayz.ir/api/classes',
    {
      method:'POST',
      withCredentials: true,
       
      headers:{
        Accept: 'application/json',
        Authorization: 'Bearer ' + global.token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        limit : 10,
        offset : 0,
        date:formatedDate ,
      })
    })
    .then(response => response.json()).then(responseJson => {
      this.setState({data : responseJson.data,
        loadingMore:
        responseJson.data.length < 10
          ? false : true,
      });
    })
    .catch(error => {
      this.setState({connectionToast:false})
    });
  }

  render() {
    console.log(global.filters.level)

    return (
      <View style={{height:Dimensions.get('window').height, backgroundColor: '#ebebeb'}}>

      <Appbar.Header>

      <View style={{flex:1,backgroundColor:'white', flexDirection:'row',justifyContent:'space-between',paddingHorizontal:10}}>

<Image style={{ height: 24 ,width:200,position:'absolute', bottom:0,left:(Dimensions.get('window').width/2)-100 }} resizeMode='stretch' source={require('../assets/tab.png')}/>
<IconButton icon="menu" color="#3a3635" size={20} style={{margin:0}} onPress={()=>this.props.navigation.openDrawer()}/>
<Text style={{marginLeft:'auto',marginRight:'auto',color:'white',marginTop:12,zIndex:100}}>{days[this.state.dIndex].format('MMMM') + ' ماه' }</Text>
<Menu 
    visible={this.state.visibleSort}
    onDismiss={this._closeSortMenu}
    style={{marginTop:8,marginRight:20}}
    anchor={
      <IconButton onPress={()=> this._openSortMenu()} icon="sort" color="#3a3635" size={20} style={{margin:0}} />
    }
  >
    <Menu.Item onPress={() => {
      global.filters.order='start';
      this._handleRefresh();
      this._closeSortMenu();
      }} title="زمان" />
    <Menu.Item onPress={() => {
      global.filters.order='price';
      this._handleRefresh();
      this._closeSortMenu();
      }} title="ارزان ترین" />
    <Menu.Item  onPress={() => {
      global.filters.order='popularity';
      this._handleRefresh();
      this._closeSortMenu();
      }} title="محبوب ترین" />
</Menu>

</View>




      </Appbar.Header>

      <View style={{backgroundColor:'#21706C',zIndex:100,elevation:5,marginTop:-12}} >

           <ScrollView horizontal={true} showsHorizontalScrollIndicator={false} style={{paddingBottom:4,}} contentContainerStyle={{flexDirection:'row'}} >
                 {
                    days.map((value,index) => {
                    return(
                      <View style={{width:width}} key={index}>
                        <Text style={{marginLeft:'auto',marginRight:'auto',color:'white',fontSize:12,marginTop:3,marginBottom:3}}>{value.format('ddd')}</Text>
                        {
                          this.state.dIndex!=index ? (<TouchableOpacity style={{height:30,width:30,backgroundColor:'#21706C',borderRadius:15,marginLeft:'auto',marginRight:'auto'}}
                          onPress={()=>{
                            let today = new Date() ;
                            let date = new Date( today.getFullYear(), today.getMonth(), today.getDate() + index ) ;
                            let formatedDate = date.getFullYear()+'/'+(date.getMonth()+1 )+'/'+date.getDate();
                            global.filters.date = formatedDate ;
                            global.acDate = new persianDate().add('days', index);;
                            this.setState({dIndex:index}) ;
                            this._handleRefresh() ;
                            }}>
                          <Text style={{marginLeft:'auto',marginRight:'auto',color:'white',marginTop:4}}>{value.format('D')}</Text>
                          </TouchableOpacity>) : (<View style={{height:30,width:30,backgroundColor:'white',borderRadius:15,marginLeft:'auto',marginRight:'auto'}}>
                          <Text style={{marginLeft:'auto',marginRight:'auto',marginTop:4}}>{value.format('D')}</Text>
                          </View>)
                        }
                      </View>
                    )
                  }) 
                }
           </ScrollView>

           <View style={{justifyContent:'center',marginHorizontal:12,backgroundColor:'#2a8f8a',borderRadius:10,marginBottom:3,marginTop:3}}>
{/* 
           <Slider
             value={global.filters.period == null? 0 : parseInt(global.filters.period)+1}
             minimumValue={0}
             maximumValue={3}
             step={1}
             trackColor={'#2a8f8a'}
             progressTrackColor={'#2a8f8a'}
             thumbStyle={{width:100}}
             thumbColor='white'
             onComplete={(value)=>{
               if(value ==1){
                global.filters.period = '0'
               }else if(value ==2){
                global.filters.period = '1'
              }else if(value ==3){
                global.filters.period = '2'
              }else {
                global.filters.period = null
              }
              console.log(global.filters.period )
              this._handleRefresh();
             }}
           /> */}

        <Slider
          value={global.filters.period == null? 0 : parseInt(global.filters.period)+1}
          minimumValue={0}
          maximumValue={3}
          step={1}
          onSlidingComplete={(value)=>{
            if(value ==1){
             global.filters.period = '0'
            }else if(value ==2){
             global.filters.period = '1'
           }else if(value ==3){
             global.filters.period = '2'
           }else {
             global.filters.period = null
           }
           console.log(global.filters.period )
           this._handleRefresh();
          }}
          inverted={true}
          minimumTrackTintColor={'#2a8f8a'}
          maximumTrackTintColor={'#2a8f8a'}
          thumbTintColor={'white'}
        />
           </View>

           <View style={{flexDirection:'row', justifyContent:'space-between',paddingHorizontal:10,marginBottom:3}}>
             <Text style={{fontSize:9, color:'white'}}>6 تا 24</Text>
             <Text style={{fontSize:9, color:'white'}}>6 تا 12</Text>
             <Text style={{fontSize:9, color:'white'}}>12 تا 18</Text>
             <Text style={{fontSize:9, color:'white'}}>18 تا 24</Text>
           </View>

        </View>

  
        <FlatList contentContainerStyle={styles.content}
          data={this.state.data}
          keyExtractor={item => item.id.toString()}
          renderItem={({ item }) => (
            <Card style={styles.card}
            onPress={() => {
              global.activeClassId = item.id;
              global.activeClassInfo = item;
              this.props.navigation.push('Class')
              }}>

        <Card.Title title={item.classname}
          subtitle={'باشگاه '+item.gymname}
          left={(props) => <Avatar.Image {...props} style={{backgroundColor:'#21706c'}} size={48} source={sportIcons[item.sport]} />}
          right={() => <TimeStamp starttime={item.starttime} endtime={item.endtime}/>}
          />
        <Card.Content>
         <View  style={{flexDirection:'row',justifyContent:'space-between'}}>
           <View style={{flexDirection:'row',flex:1}}>
             <IconButton icon="human" color='#3a3635' size={18} style={{margin:0,marginTop:-5,marginLeft:-6,marginRight:-3}} />
             <Text numberOfLines={1} style={{color:'#3a3635',fontSize:12,paddingLeft:10,maxWidth:170}}>{item.trainer}</Text>
             <Text style={{color:'#3a3635',fontSize:12,paddingLeft:4}}>/   امتیاز :</Text>
             {item.avgrate == null ? <Text>-</Text> :
             <Rating
               readonly={true}
               ratingColor="gold"
               imageSize={12}
               startingValue={item.avgrate}
               style={{marginTop:4, height:'100%'}}
              />}
           </View>

           <View style={{flexDirection:'row',marginTop:-5}}>
             <Text style={{fontSize:20.5, color:'#21706c'}}>{item.price/1000}</Text>
             <View style={{marginLeft:6}}>
               <Text style={{fontSize:12.5, color:'#21706c'}}>هزار</Text>
               <Text style={{fontSize:10,marginTop:-8, color:'#21706c'}}>تومان</Text>
             </View>

           </View>
         </View>

         <Divider  />
         
         <View style={{flexDirection:'row',justifyContent:'space-between',marginTop:12}}>

         <View style={{flexDirection:'row'}}>
           <IconButton icon="map-marker-outline" color='#3a3635' size={18} style={{margin:0,marginTop:-5,marginLeft:-6,marginRight:-3}} />
           <Text numberOfLines={1} style={{color:'#3a3635',fontSize:12}}>{item.address}</Text>
         </View>

         <IconButton icon="chevron-left" color='#3a3635' size={30} style={{margin:-15}} />
         </View>
           
        </Card.Content>

      </Card>
          )}

          onEndReached={this._handleLoadMore}
          onEndReachedThreshold={0.5}
          initialNumToRender={10}
          ListFooterComponent={this._renderFooter}
          onRefresh={this._handleRefresh}
          refreshing={this.state.refreshing}
          />  

        
        <FAB
              icon="filter"
              color='white'
              style={styles.fab3}
              onPress={() =>
                this.props.navigation.navigate('Filter', { onGoBack: this._handleRefresh })
              }
            />

<Snackbar
          style={{zIndex:200}}
          visible={this.state.connectionToast}
          onDismiss={() => this.setState({connectionToast:false})}>
         ارتباط اینترنت با مشکل مواجه است
        </Snackbar>

      </View>

      
    );
  }
}
const styles = StyleSheet.create({
  content: {

    padding: 4,
    backgroundColor:'#ebebeb',
    
  },
  card: {
    margin: 4,
  },
  fab3: {
    right:0,
    position: 'absolute',
    backgroundColor:'#21706C',
    bottom: 0,
    margin: 16,
    elevation: 10,
  },
});



